import { render } from "./OverScrollNotice.vue?vue&type=template&id=30d8d034&scoped=true"
import script from "./OverScrollNotice.vue?vue&type=script&lang=ts"
export * from "./OverScrollNotice.vue?vue&type=script&lang=ts"

import "./OverScrollNotice.vue?vue&type=style&index=0&id=30d8d034&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-30d8d034"

export default script